module.exports = __webpack_public_path__ + "img/0Q3B1891_Mockup.2e645ebd.jpg";